import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { useQuery } from "@apollo/client/react";

import { WAREHOUSE_NAMES } from "../../constants/graphql/queries";
import SelectWarehouse from "./SelectWarehouse";
import Warehouse from "./Warehouse";

export const WarehouseContext = React.createContext(null);

export default function WarehouseList({ modal, warehouseMapFilters }) {
  const [id, setId] = React.useState(warehouseMapFilters?.warehouse?.id);
  const [view, setView] = React.useState("table");
  const { data: { warehouses } = {}, loading } = useQuery(WAREHOUSE_NAMES, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { userWarehouses: true },
  });

  const changeWarehouse = id => {
    setId(id);
    setView("table");
  };

  if (loading) {
    return <LinearProgress className="mt-2" />;
  }

  if (id) {
    return (
      <WarehouseContext.Provider value={warehouses.find(v => v.id === id)}>
        <Warehouse
          id={id}
          view={view}
          modal={modal}
          changeWarehouse={changeWarehouse}
          changeView={setView}
          excludeType={warehouseMapFilters ? "mobile" : null}
        />
      </WarehouseContext.Provider>
    );
  }

  return (
    <SelectWarehouse modal={modal} warehouses={warehouses} changeWarehouse={changeWarehouse} />
  );
}
